import superagent from 'superagent';
//import webservice from './webservice';
import getCookie from './getCookie';

export default async function postPagos(form) {
  let webservice = 'https://terramarbrands.mx/wsTerramar/Service1.svc';
  let jsonPost = {
    usuarioOK: getCookie('usuarioOk'),
    kitMerchant: form.kit,
    monto: form.paytotal,
    enlaceRetorno: `${webservice}/pagosConfirmacion.aspx`,
    dominio: window.location.hostname,
  };

  console.log(jsonPost);

  const url = `${webservice}/postPagos`;

  let response = {};

  await superagent
    .post(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .send(jsonPost)
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      alert('Error redirigir al sistema de pagos.');
      console.log(err);
    });

  return response;
}
